// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__BAsgo","brandText":"footer_brandText__PVmHc","logo":"footer_logo__f8S1c","creditText":"footer_creditText__UY983","link":"footer_link__wstjM"};